// extracted by mini-css-extract-plugin
export var divider = "_pb-0";
export var systemMessage = "_pb-1";
export var systemMessageWrapper = "_pb-2";